import React from 'react'
import Header from '../components/Layout/header'

const ErrorComponent = () => {
  return (
    <div id="main-wrapper">
      <Header showSidebar={() => { }} sidebar={false} hideSidebarIcon={true}></Header>
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="page-content error-component">
            Something went wrong :-(
            <br />
            Please make sure your internet is connected & try after sometime.
            <br/>
            <a  href="" onClick={() => window.location.reload()}>Refresh here</a>
        </div>
        </div>
      </div>
    </div>)
}

export default ErrorComponent
